export const scrollTo = (name: string) => {
    // react-scroll got broken with the new flex layout
    // this is a temporary scroll replacement
    const element = document.querySelector(`div[name="${name}"]`);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
    // TODO replace with this: scroller.scrollTo(Object.keys(formRef.current.errors)[0], { duration: 800, delay: 200, offset: -100, smooth: true });
};
